import React, { useRef, useState, useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { CForm, CFormLabel, CCol, CRow, CFormCheck } from '@coreui/react';
import CookieFunctions from '../functions/CookieFunctions';
import ManagerPending from './ManagerPending';
import { toast } from 'react-toastify';

const ManagerSearch = () => {
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [open, setOpen] = useState(-1)

    // users options to select from
    const [driverOptions, setDriverOptions] = useState([]);
    const [tlOptions, setTlOptions] = useState([]);

    // by driver
    const [driverId, setDriverId] = useState(null);
    const [myDrivers, setMyDrivers] = useState(false);

    // by terminal
    const [terminalDrivers, setTerminalDrivers] = useState(false);
    const [teamleader, setTeamleader] = useState(null);

    // request data to show
    const [requests, setRequests] = useState([]);

    const search = useRef();

    function getRequests(by, status, id = null) {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        let url;
        let method;

        // terminal, teamleader, driver
        switch (by) {
            case "driver":
                url = `/api/manager/${id}/pending/requests`;
                method = 'GET'
                break;
            default: // currently only terminal or teamleader
                url = `api/manager/${by}/${status}/requests`;
                if (id) formData.append("teamleader", id.trim())
                method = 'POST'
        }

        let headers;
        switch (method) {
            case "GET":
                headers = { headers: myHeaders, method: method, }
                break;
            case "POST":
                headers = { headers: myHeaders, method: method, body: formData }
                break;
            default:

        }

        fetch(url, headers).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setRequests(data);
        })
    }

    const fetchDrivers = () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/manager/getAllDrivers", {
            headers: myHeaders,
            method: 'GET'
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error();
                }
            })
            .then((data) => {
                setDriverOptions(data);
                setIsLoading(false);
            })
            .catch((e) => {
                setError("Error occurred while fetching drivers.");
                setIsLoading(false);
            });
    };

    const fetchTeamleaders = () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/manager/TLByTerminal", {
            headers: myHeaders,
            method: 'GET'
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error();
                }
            })
            .then((data) => {
                setTlOptions(data);
                setIsLoading(false);
            })
            .catch((e) => {
                setError("Error occurred while fetching drivers.");
                setIsLoading(false);
            });
    };

    function validate(status) {
        var err = "";

        if (status === null) {
            err = "Must select Approve or Reject"
        }

        return err
    }

    function onSubmit(i, status, commentsToDriver, commentsToTMW) {
        setError(null)
        setLoadingData(true)

        var valid = validate(status)

        if (valid !== "") {
            setError(valid)
            setLoadingData(false)
            return
        }

        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();
        formData.append("reqId", requests[i].id)
        formData.append("commentsToDriver", commentsToDriver)
        formData.append("commentsToTMW", commentsToTMW)

        fetch(`/api/manager/request/${status}`,
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                toast.success("A request has been updated!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });

                setOpen(-1)

                const newRequests = [...requests];
                if (newRequests[i]) {
                    newRequests.splice(i, 1)
                    setRequests(newRequests);
                }
            } else if (res.status === 400) {
                return res.text()
            }
        }).then((data) => {
            setError(data);
        })

        setLoadingData(false)
    }

    const handleDriverSelection = (selected) => {
        if (selected.length === 1) {
            setDriverId(selected[0].mpp_id);
            setMyDrivers(false)
            setTerminalDrivers(false)
            getRequests("driver", "pending", selected[0].mpp_id)
        }
    };


    const handleTLSelection = (selected) => {
        if (selected.length === 1) {
            setTeamleader(selected[0].email);
            setMyDrivers(false)
            setTerminalDrivers(false)
            getRequests("teamleader", "pending", selected[0].email)
        }
    };

    function handleShowMyDrivers(show) {
        setMyDrivers(show)
        if (show) {
            setDriverId(null)
            setTeamleader(null)
            getRequests("teamleader", "pending")
        } else {
            setRequests([])
        }
    }

    function handleShowTerminalDrivers(show) {
        setTerminalDrivers(show)
        if (show) {
            setDriverId(null)
            setTeamleader(null)
            getRequests("terminal", "pending")
        } else {
            setRequests([])
        }
    }

    useEffect(() => {
        fetchDrivers();
        fetchTeamleaders();
    }, []);

    return (
        <>
            <CForm className='fs-4'>
                <CRow>
                    <CCol sm="4" xs="6">
                        <CFormLabel className='fs-4'>Search by Driver Name</CFormLabel>
                        <Typeahead
                            id="manager-search"
                            isLoading={isLoading}
                            labelKey={option => `${option.mpp_firstname} ${option.mpp_lastname} (${option.driver_type === "CO" ? option.mpp_id : option.trc_number})`}
                            onChange={handleDriverSelection}
                            options={driverOptions}
                            ref={search}
                        />
                    </CCol>
                    <CCol sm="4" xs="6">
                        <CFormLabel className='fs-4'>Search by Team Leader</CFormLabel>
                        <Typeahead
                            id="tl-search"
                            isLoading={isLoading}
                            labelKey={tlOptions => `${tlOptions.employeeName}`}
                            onChange={handleTLSelection}
                            options={tlOptions}
                            ref={search}
                        />
                    </CCol>
                </CRow>
                <CRow className="my-2">
                    <CCol sm="4">
                        <CFormCheck className='fs-4' label="Show my Drivers" checked={myDrivers} onChange={(e) => { handleShowMyDrivers(e.target.checked) }} disabled={(terminalDrivers) ? true : false} />
                    </CCol>
                    <CCol sm="4">
                        <CFormCheck className='fs-4' label="Show My Terminal Drivers" checked={terminalDrivers} onChange={(e) => { handleShowTerminalDrivers(e.target.checked) }} disabled={(myDrivers) ? true : false} />
                    </CCol>
                </CRow>
                {error && <p>{error}</p>}
            </CForm>
            <br />

            {(driverId || myDrivers || terminalDrivers || teamleader) ? <>
                <ManagerPending requests={requests} onSubmit={onSubmit} loading={loadingData} open={open} setOpen={setOpen} />
            </> : null}
        </>

    );
};

export default ManagerSearch;
